<template>
    <div class="login-wrap" ref="login">
        <section class="login-container">
            <div class="login-container-header">
                <h3>乐纯管理平台登录</h3>
            </div>
            <div style="padding:10px 0;text-align: center;font-size: 14px;font-weight: bolder">
                <el-button type="primary" @click="dingLoginPage" v-if="isLogin">创建智能会议</el-button>
                <span v-else > <i style="font-size: 20px" class="el-icon-loading"></i> 登录中。。。。请稍后</span>
            </div>

        </section>
    </div>
</template>

<script>
    import * as dd from 'dingtalk-jsapi';
    import { resolveLoginReturn, appendLoginDisplayFields } from '@/utils/login-return'
    export default {
        data() {
            return {
                isLogin:false,
                imgCode:'',
                showValidateCode:'',
                corpId:'ding5473140ac462716435c2f4657eb6378f',
                clientId:'dingqtyl0pccf1xzawht',
                code:this.$route.query.code||'',
                returnPage: this.$route.query.returnPage,
                userId:'',
                userName:'',
                userNick:'',
                form: {
                    userName:'',
                    passWord:'',
                    imageValidateCode:null
                },
                isInDingTalk:/DingTalk|DingTalkBrowser/.test(navigator.userAgent)
            }
        },
        mounted(){
            if(this.isInDingTalk){
                dd.runtime.permission.requestAuthCode({
                    corpId: this.corpId,
                    clientId: this.clientId,
                    onSuccess: (result)=> {
                        this.DingLogin(result.code,'ding')
                    },
                    onFail: (err)=> {
                        this.$message({
                            showClose: false,
                            message: '登录失败，请重试',
                            type: 'error'
                        });
                    },
                });
            }else{
                
            }

        },
        methods: {
            returnPageFun(){
                const target = resolveLoginReturn(this.$route.query.returnPage, window.location.origin,
                    process.env.VUE_APP_LOGIN_RETURN_TARGETS, process.env.VUE_APP_LOGIN_RETURN_ORIGINS)
                if (!target) {
                    this.$router.push('dashboard')
                    return
                }
                const destination = this.$route.query.auth == 2
                    ? appendLoginDisplayFields(target, { userId: this.userId, userNick: this.userNick })
                    : target.href
                window.location.replace(destination)
            },
            DingLogin(code,from){
                let param = from=='ding'? {code,corpId:this.corpId}:{code}
                this.$apiGet('lechun-baseservice/auth/loginDingDing',{...param}).then(res=>{
                    console.log(res)
                    this.$message({
                        showClose: true,
                        message: '登录成功',
                        type: 'success'
                    });
                    window.localStorage.setItem('userId',res.userId);
                    this.userId = res.userId
                    this.userName = res.userName
                    this.userNick = res.userNick
                    this.isLogin = true
                })
            },
            dingLoginPage(){
                dd.makeVideoConfCall({
                    title: '测试视频会议',
                    calleeCorpId: this.corpId,
                    calleeStaffIds: [],
                    success: () => {},
                    fail: () => {},
                    complete: () => {},
                });
            }
        }
    }
</script>


<style lang="scss" rel="stylesheet/scss">
    .login-wrap{
        width: 100%;
        height: 100%;
        background: url("../assets/images/blur-bg.jpg");
        background-size: cover;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        .login-container{
            width: 480px;
            background-color: rgba(0,0,0,.5);
            border: none;
            border-radius: 5px;
            position: relative;
            margin-bottom: 24px;
            box-shadow: 0 5px 5px 0 rgba(0,0,0,.25);
            .el-form-item__label{
                color: #ffffff;
            }
            &-header{
                border-bottom: 1px solid rgba(0,0,0,.12);
                line-height: 55px;
                box-shadow: 0 1px 0 0 rgba(255,255,255,.12);
                box-sizing: border-box;
                h3{
                    margin: 0;
                    font-size: 20px;
                    text-align: center;
                }
            }
            &-body{
                padding: 15px 22px;
                box-sizing: border-box;
                .forget-password{
                    display: flex;
                    justify-content: flex-end;
                    font-size: 12px;
                    margin: -10px 0 20px;
                    span{
                        cursor: pointer;
                    }
                }
                .img-input{
                    .el-input-group__append{
                        background: #ffffff;
                    }
                }
            }
        }
        .el-tabs--border-card{
            background: transparent;
            border:none;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.32), 0 0 6px 0 rgba(0, 0, 0, 0.24);
        }

        .el-tabs--border-card > .el-tabs__header{
            background: transparent;
            border-bottom: 1px solid rgba(0, 0, 0, 0.12);
            box-shadow: 0 1px 0 0 rgba(255, 255, 255, 0.12);
        }
        .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active{
            color: #ffffff;
            background-color: #209e91;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            border:none;
        }

    }

</style>
